import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import router from '@/router';
import { errorHandler } from '@/utils';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../constants';
import type { ILoginResponse } from '../types';
import apiClient from '@/service';
import { useAppStore } from '@/store/appStore';
export interface ApiResponse<T> {
  status: number;
  message: string;
  code: number;
  data: T;
  dataTime: string;
  httpStatus: string;
}
export const useSignStore = defineStore('SignStore', {
  state: () => ({
    token: '',
  }),
  actions: {
    async login(id: string, passwd: string) {
      return apiClient
        .post<ILoginResponse>('/user/login', { id, passwd })
        .then(async ({ data: { data } }) => {
          return new Promise(async (resolve) => {
            this.token = data.accessToken;
            await this.setAccessToken(data.accessToken);
            await this.setRefreshToken(data.refreshToken);
            // 토큰 설정이 완전히 완료된 후에만 true 반환
            resolve(true);
          });
        })
        .catch((err) => {
          errorHandler(err);
          return false;
        });
    },
    async refreshToken(config?: any): Promise<boolean> {
      // config에 이미 Authorization 헤더가 있으면 그것을 사용, 없으면 쿠키에서 가져옴
      let requestConfig = config;

      if (!requestConfig?.headers?.Authorization) {
        const refreshToken = Cookies.get(REFRESH_TOKEN_KEY);

        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        requestConfig = {
          headers: {
            Authorization: 'Bearer ' + refreshToken,
          },
        };
      }

      return apiClient
        .post<ILoginResponse>('/user/refresh-token', {}, requestConfig)
        .then(async ({ data: { data } }) => {
          this.token = data.accessToken;
          await this.setAccessToken(data.accessToken);
          await this.setRefreshToken(data.refreshToken);
          return true;
        })
        .catch((error) => {
          throw error;
        });
    },
    async setAccessToken(token: string) {
      await Cookies.set(ACCESS_TOKEN_KEY, token, {
        path: '/',
        sameSite: 'lax',
      });
    },
    async setRefreshToken(token: string) {
      const maxAge = 7;
      await Cookies.set(REFRESH_TOKEN_KEY, token, {
        expires: maxAge,
        path: '/',
        sameSite: 'lax',
      });
    },
    async getAccessToken() {
      const token = Cookies.get(ACCESS_TOKEN_KEY);
      const refreshToken = Cookies.get(REFRESH_TOKEN_KEY);
      if (!token) {
        if (refreshToken) {
          await this.refreshToken();
          return;
        }
        router.push('/sign');
      } else {
        this.token = token;
      }
      return this.token;
    },
    getRefreshToken() {
      return Cookies.get(REFRESH_TOKEN_KEY);
    },
    logout() {
      this.token = '';
      Cookies.remove(ACCESS_TOKEN_KEY, { path: '/' });
      Cookies.remove(REFRESH_TOKEN_KEY, { path: '/' });
      localStorage.removeItem('current');
      localStorage.removeItem('tabs');
      useAppStore().resetTabs();
      router.push('/sign');
    },
  },
});
